import React, { useEffect, useRef, useState } from 'react';
import './LeftTabs.css';
import Loader from '../Loader/Loader';
import {Home} from "lucide-react";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


const LeftTabs = ({
                      queries,
                      deeperQuestion,
                      onMessageSelect,
                      allMessages,
                      selectedMessageId,
                      onQuestionSelect
                  }) => {
    const [activeTab, setActiveTab] = useState('prompts');
    const contentRef = useRef(null);
    const [copiedIndex, setCopiedIndex] = useState(null);
    const navigate = useNavigate();
    const { t } = useTranslation();


    useEffect(() => {
        if (contentRef.current) {
            contentRef.current.scrollTop = 0;
        }
    }, [activeTab]);

    const handlePromptClick = (query, messageId) => {
        const searchInput = document.querySelector('.search-input');
        if (searchInput) {
            searchInput.value = query;
            const event = new Event('input', { bubbles: true });
            Object.defineProperty(event, 'target', { value: searchInput });
            searchInput.dispatchEvent(event);
        }

        if (onMessageSelect && messageId) {
            onMessageSelect(query, messageId);
        }
    };

    const handleQuestionClick = (questionText) => {
        const searchInput = document.querySelector('.search-input');
        if (searchInput) {
            searchInput.value = questionText.trim();
            const event = new Event('input', { bubbles: true });
            Object.defineProperty(event, 'target', { value: searchInput });
            searchInput.dispatchEvent(event);
        }
        if (onQuestionSelect) {
            onQuestionSelect(questionText.trim());
        }
    };

    const formatDeeperQuestions = (questionsString) => {
        if (!questionsString) return null;
        try {
            let cleanedText = questionsString.trim();
            if (cleanedText.startsWith('[') && cleanedText.endsWith(']')) {
                cleanedText = cleanedText.substring(1, cleanedText.length - 1);
            }

            const questions = cleanedText
                .split(/,\s*(?=\d+\.)/)
                .map(q => q.trim())
                .filter(q => q);

            return (
                <div className="deeper-questions-list">
                    {questions.map((question, index) => {
                        const match = question.match(/^(\d+)\.\s*(.*)/);
                        const number = match ? match[1] : index + 1;
                        const text = match ? match[2] : question;

                        return (
                            <div
                                key={index}
                                className="deeper-question-item"
                                onClick={() => handleQuestionClick(text)}
                            >
                                <div className="question-number"> {t('Soru')} {number}</div>
                                <div className="question-content">
                                    {text.trim()}
                                </div>
                            </div>
                        );
                    })}
                </div>
            );
        } catch (e) {
            console.error("Error parsing deeper questions:", e);
            return <p>{questionsString}</p>;
        }
    };

    return (
        <div className="left-section">
            <div className="absolute bottom-4 left-4">
                <button
                    onClick={() => navigate('/')}
                    className="p-2 rounded-full hover:bg-gray-200 transition-colors duration-200"
                    title="Ana Sayfaya Dön"
                >
                    <div className="fixed bottom-4 left-4 z-50 cursor-pointer hover:scale-110 transition-transform">
                        <Home size={24} className="text-[#3c4f58] hover:text-[#2c3e48]"/>
                    </div>

                </button>
            </div>

            <div className="left-tabs-container">
                <button
                    className={`left-tab ${activeTab === 'prompts' ? 'active' : ''}`}
                    onClick={() => setActiveTab('prompts')}
                >
                     {t('Yazılarım')}
                </button>
                <button
                    className={`left-tab ${activeTab === 'deepen' ? 'active' : ''}`}
                    onClick={() => setActiveTab('deepen')}
                >
                     {t('Makaleyi Derinleştir')}
                </button>
            </div>

            <div className="left-tab-content">
                {activeTab === 'prompts' && (
                <div className="scrollable-content" ref={contentRef}>
                {!allMessages || allMessages.length === 0 ? (
                    !queries || queries.length === 0 ? (
                        <p className="empty-message">Sorgularınız burada görünecek...</p>
                    ) : (
                        <div className="prompts-list">
                            {queries.map((query, index) => {
                                const message = allMessages?.find(m => m.query === query);
                                const messageId = message?.id;
                                const isSelected = messageId === selectedMessageId;
            
                                return (
                                    <div
                                        key={index}
                                        className={`prompt-item ${isSelected ? 'selected' : ''}`}
                                        onClick={() => handlePromptClick(query, messageId)}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        {query}
                                    </div>
                                );
                            })}
                        </div>
                    )
                ) : (
                    <div className="prompts-list">
                        {allMessages.map((message, index) => {
                            const messageId = message?.id;
                            const isSelected = messageId === selectedMessageId;
            
                            return (
                                <div
                                    key={index}
                                    className={`prompt-item ${isSelected ? 'selected' : ''}`}
                                    onClick={() => handlePromptClick(message.query, messageId)}
                                    role="button"
                                    tabIndex={0}
                                >
                                    {message.query}
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
            
                )}
                {activeTab === 'deepen' && (
                    <div className="scrollable-content" ref={contentRef}>
                        {deeperQuestion === null || deeperQuestion === undefined ? (
                            <Loader/>
                        ) : (
                            formatDeeperQuestions(deeperQuestion)
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default LeftTabs;